<template>
  <div id="a">
    <el-card>
      <el-row class="user-options__title">渠道更新</el-row>
      <!-- 搜索 -->
      <el-row class="room_tab__search">
        <span>渠道：</span>
        <el-select style="width: 160px" v-model="curChannel.selectValue" filterable placeholder="">
          <el-option v-for="(item, itemIndex) in channels" v-bind:key="itemIndex" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-button style="margin-left: 10px" type="success" @click="getConfig">搜索</el-button>
        <a href="#content"><el-button style="margin-left: 10px" type="success" @click="add">添加</el-button></a>
      </el-row>
      <!-- 表格 -->
      <el-row>
        <el-table border :data="table">
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column prop="updateName" label="版本更新名称" align="center">
          </el-table-column>
          <el-table-column prop="channel" label="原渠道" align="center">
          </el-table-column>
          <el-table-column prop="newVersion" label="新版本号" align="center">
          </el-table-column>
          <el-table-column prop="changedChannel" label="更新渠道" align="center">
          </el-table-column>
          <el-table-column prop="changedChannel" label="更新类型" align="center">
            <template slot-scope="scope">
              {{
                scope.row.updateType === 0
                  ? '非强更'
                  : scope.row.updateType === 1
                    ? '强更'
                    : '自动更新'
              }}
            </template>
          </el-table-column>
          <el-table-column prop="updatePromptInterval" label="间隔时间" align="center">
          </el-table-column>
          <el-table-column prop="defaultAppUrl" label="更新链接" align="center">
          </el-table-column>
          <el-table-column prop="windowsTitle" label="弹窗标题" align="center">
          </el-table-column>
          <el-table-column prop="updateDesc" label="弹窗正文" width="260" align="center">
          </el-table-column>
          <el-table-column prop="sendGold" label="赠送金币数" align="center">
          </el-table-column>
          <el-table-column prop="newAppLogo" label="logo" align="center">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: auto" :src="scope.row.newAppLogo"
                :preview-src-list="[scope.row.newAppLogo]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="videoUrl" label="背景视频" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.videoUrl" style="position: relative; display: inline-block;">
                <video 
                  style="width: 100px; height: 60px; object-fit: cover; cursor: pointer; border: 1px solid #ddd;"
                  :src="scope.row.videoUrl"
                  @click="previewVideo(scope.row.videoUrl)"
                  muted
                  preload="metadata">
                </video>
                <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.3); cursor: pointer;"
                  @click="previewVideo(scope.row.videoUrl)">
                  <i class="el-icon-video-play" style="color: #fff; font-size: 24px;"></i>
                </div>
              </div>
              <span v-else style="color: #999;">-</span>
            </template>
          </el-table-column>
          <el-table-column label="更新展示图" align="center">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: auto" :src="scope.row.displayPic1"
                :preview-src-list="[scope.row.displayPic1]">
              </el-image>
              <el-image style="width: 100px; height: auto" :src="scope.row.displayPic2"
                :preview-src-list="[scope.row.displayPic2]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="是否是付费用户" align="center">
            <template slot-scope="scope">
              {{ scope.row.payUserUpdateSwitch === 0 ? '否' : '是' }}
            </template>
          </el-table-column>
          <el-table-column prop="payTotalAmount" label="付费金额" align="center">
          </el-table-column>
          <el-table-column label="是否是活跃用户" align="center">
            <template slot-scope="scope">
              {{ scope.row.activeUserUpdateSwitch === 0 ? '否' : '是' }}
            </template>
          </el-table-column>
          <el-table-column prop="activeTotalDays" label="活跃天数" align="center">
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center">
          </el-table-column>
          <el-table-column prop="ctime" :formatter="formatDate" label="创建时间" align="center">
          </el-table-column>
          <el-table-column prop="mtime" :formatter="formatDate" label="修改时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="320">
            <template slot-scope="scope">
              <a href="#content">
                <el-button type="primary" @click="change(scope.row, 1)">修改</el-button>
              </a>
              <el-button type="success" @click="copyConfig(scope.row)">复制</el-button>
              <el-button type="danger" @click="change(scope.row, 2)">删除</el-button>
              <el-button type="info" @click="change(scope.row, 3)">{{
                scope.row.active === 0 ? '生效' : '无效'
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <div class="app_update_page" style="position: relative" id="content">
      <!-- <h1>渠道更新</h1> -->
      <!-- <div class="user-options clearfix">
        <el-select
          style="width: 160px"
          v-model="curChannel.selectValue"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in channels"
            v-bind:key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="getConfig">查询</el-button>
      </div> -->
      <div class="content clearfix" v-show="showDetail">
        <el-form ref="form" :model="formData" label-width="200px" :rules="rules">
          <el-form-item label="渠道" prop="channel">
            <el-input class="input_item" :disabled="formData.active === 1" v-model="formData.channel"></el-input>
          </el-form-item>

          <el-form-item label="版本更新名称" prop="updateName">
            <el-input class="input_item" v-model="formData.updateName"></el-input>
          </el-form-item>

          <el-form-item label="更新后渠道名" prop="changedChannel">
            <el-select style="width: 160px" filterable v-model="formData.changedChannel" placeholder="">
              <el-option v-for="(item, itemIndex) in channels" v-bind:key="itemIndex" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="新包版本号" prop="newVersion">
            <el-input class="input_item" v-model="formData.newVersion"></el-input>
          </el-form-item>

          <el-form-item label="新包版本名字">
            <el-input class="input_item" v-model="formData.newVersionName"></el-input>
          </el-form-item>

          <el-form-item label="弹窗图片" required>
            <el-upload class="upload-demo" ref="upload1" action="" list-type="picture" :limit="1"
              :on-change="(value) => changeFile2(4, value)" :auto-upload="false">
              <el-button slot="trigger" type="primary"> 选择图片 </el-button>
            </el-upload>
            <el-image style="width: 100px; height: 100px" :src="formData.imgUrl" :preview-src-list="[formData.imgUrl]"
              fit="contain">
            </el-image>
          </el-form-item>

          <el-form-item label="app默认url" prop="defaultAppUrl">
            <el-input class="input_item" v-model="formData.defaultAppUrl"></el-input>
          </el-form-item>

          <el-form-item label="url1(armv7)" prop="appUrl1">
            <el-input class="input_item" v-model="formData.appUrl1"></el-input>
          </el-form-item>
          <el-form-item label="url2(armv8)" prop="appUrl2">
            <el-input class="input_item" v-model="formData.appUrl2"></el-input>
          </el-form-item>
          <el-row><el-button style="margin: 0 0 20px 200px" type="primary" @click="
            () => {
              dialogType = 0
              dialogTextListShow = true
            }
          ">弹窗文案设置</el-button></el-row>
          <el-button style="margin: 0 0 20px 200px" type="primary" @click="
            () => {
              dialogType = 1
              dialogTextListShow = true
            }
          ">弹窗悬浮文案设置</el-button>
          <el-form-item label="赠送金币数" prop="sendGold">
            <el-input class="input_item" v-model="formData.sendGold"></el-input>
          </el-form-item>
          <el-form-item label="更新展示图1">
            <el-upload class="upload-demo" ref="upload2" action="" list-type="picture" :show-file-list="false"
              :limit="1" :on-change="(value) => changeFile2(1, value)" :auto-upload="false">
              <el-button slot="trigger" type="primary"> 选择图片 </el-button>
            </el-upload>
            <el-image style="width: 100px; height: 100px" :src="formData.displayPic1"
              :preview-src-list="[formData.displayPic1]" fit="contain">
            </el-image>
          </el-form-item>
          <el-form-item label="更新展示图2">
            <el-upload class="upload-demo" ref="upload3" action="" list-type="picture" :show-file-list="false"
              :limit="1" :on-change="(value) => changeFile2(2, value)" :auto-upload="false">
              <el-button slot="trigger" type="primary"> 选择图片 </el-button>
            </el-upload>
            <el-image style="width: 100px; height: 100px" :src="formData.displayPic2"
              :preview-src-list="[formData.displayPic2]" fit="contain">
            </el-image>
          </el-form-item>
          <el-form-item label="更新的app的logo">
            <el-upload class="upload-demo" ref="upload4" action="" list-type="picture" :show-file-list="false"
              :limit="1" :on-change="(value) => changeFile2(3, value)" :auto-upload="false">
              <el-button slot="trigger" type="primary"> 选择图片 </el-button>
            </el-upload>
            <el-image style="width: 100px; height: 100px" :src="formData.newAppLogo"
              :preview-src-list="[formData.newAppLogo]" fit="contain">
            </el-image>
          </el-form-item>
          <el-form-item label="更新展示背景视频">
            <el-upload 
              class="upload-demo" 
              ref="uploadVideo" 
              action="" 
              :show-file-list="false"
              :limit="1" 
              :on-change="(value) => changeFile2(6, value)" 
              :auto-upload="false"
              accept="video/*">
              <el-button slot="trigger" type="primary" v-if="!formData.videoUrl"> 选择视频 </el-button>
            </el-upload>
            <div v-if="formData.videoUrl" style="position: relative; display: inline-block; margin-left: 10px;">
              <video 
                style="width: 100px; height: 100px; object-fit: cover; cursor: pointer; display: block;"
                :src="formData.videoUrl"
                @click="previewVideo(formData.videoUrl)"
                muted
                preload="metadata">
              </video>
              <div 
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.3); cursor: pointer;"
                @click="previewVideo(formData.videoUrl)">
                <i class="el-icon-video-play" style="color: #fff; font-size: 24px;"></i>
              </div>
              <el-button 
                type="danger" 
                size="mini" 
                icon="el-icon-delete" 
                style="position: absolute; top: 5px; right: 5px;"
                @click="removeVideo">
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="自动更新开关">
            <el-switch v-model="formData.updateSwitch" active-text="开" inactive-text="关" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item label="自动更新开始结束日期">
            <el-date-picker v-model="dateAry" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="是否开启Code码">
            <el-switch v-model="formData.migrateCodeSwitch" active-text="开启" inactive-text="关闭" active-color="#13ce66"
              inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="安卓更新类型">
            <el-switch v-model="formData.androidUpdateType" active-text="跳转浏览器" inactive-text="自动下载apk"
              active-color="#13ce66" inactive-color="#ff4949" :active-value="0" :inactive-value="1"></el-switch>
          </el-form-item>
          <el-form-item label="面向付费用户开关">
            <el-switch v-model="formData.payUserUpdateSwitch" active-text="不限制(关闭)" inactive-text="限制付费用户(打开)"
              active-color="#13ce66" inactive-color="#ff4949" :active-value="0" :inactive-value="1"></el-switch>
            <span style="margin-left: 20px">付费金额(>=)</span>
            <el-input style="width: 200px; margin-left: 20px" class="input_item"
              v-model="formData.payTotalAmount"></el-input>
            <span>单位：$</span>
          </el-form-item>
          <!-- <el-form-item label="付费金额(>=)" prop="payTotalAmount">
            <el-input
              class="input_item"
              v-model="formData.payTotalAmount"
            ></el-input>
            <span>单位：$</span>
          </el-form-item> -->
          <el-form-item label="面向活跃用户开关">
            <el-switch v-model="formData.activeUserUpdateSwitch" active-text="不限制(关闭)" inactive-text="限制活跃用户(打开)"
              active-color="#13ce66" inactive-color="#ff4949" :active-value="0" :inactive-value="1"></el-switch>
            <span style="margin-left: 20px">活跃天数(>=)</span>
            <el-input style="width: 200px; margin-left: 20px" class="input_item"
              v-model="formData.activeTotalDays"></el-input>
            <span>单位：Day</span>
          </el-form-item>
          <!-- <el-form-item label="活跃天数(>=)" prop="activeTotalDays">
            <el-input
              class="input_item"
              v-model="formData.activeTotalDays"
            ></el-input>
            <span>单位：Day</span>
          </el-form-item> -->
          <!-- 
          <el-form-item label="更新频率开关">
            <el-switch
              v-model="formData.updateFrequency"
              active-text="每日一更"
              inactive-text="说明需要一直提示更新"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1"
            ></el-switch>
          </el-form-item> -->
          <!-- <el-form-item label="更新时间间隔" prop="updatePromptInterval">
            <el-input
              class="input_item"
              v-model="formData.updatePromptInterval"
            ></el-input>
            <span>单位：S</span>
          </el-form-item> -->
          <el-form-item label="更新类型" prop="updateType">
            <el-select style="width: 160px" v-model="formData.updateType" placeholder="">
              <el-option label="非强更" :value="0"></el-option>
              <el-option label="强更" :value="1"></el-option>
              <el-option label="自动更新" :value="2"></el-option>
            </el-select>
            <span style="margin-left: 20px">更新时间间隔</span>
            <el-input style="width: 200px; margin-left: 20px" class="input_item"
              v-model="formData.updatePromptInterval"></el-input>
            <span>单位：S</span>
          </el-form-item>

          <el-form-item label="用户充值重新弹窗时间间隔">
            <el-input style="width: 200px" class="input_item"
              v-model="formData.payUpdatePromptRange" placeholder="格式：1-4"></el-input>
            <span style="margin-left: 20px">单位：S（格式：1-4，即1到4秒）</span>
          </el-form-item>

          <el-form-item label="该条配置是否生效">
            <el-switch v-model="formData.active" active-text="生效" inactive-text="不生效" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="updateConfig('form')">{{
              type === 0 ? '创建' : '更新'
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 弹出文案编辑 -->
    <el-dialog title="弹窗文案" :visible.sync="dialogTextShow" width="60%" @before-close="cancles(2)">
      <template v-if="dialogType == 0">
        <el-form :model="formData" label-width="200px">
          <el-form-item label="语言">
            <el-select v-model="dialogUpdata.langCode" style="width: 150px" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in languageLists" :key="index" :label="item.language"
                :value="item.langCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="按钮文字" prop="buttonDesc">
            <el-input class="input_item" v-model="dialogUpdata.buttonDesc"></el-input>
          </el-form-item>
          <el-form-item label="弹窗标题" prop="windowsTitle">
            <el-input class="input_item" v-model="dialogUpdata.windowsTitle"></el-input>
          </el-form-item>
          <el-form-item label="文本模式">
            <el-select v-model="modes" style="width: 150px" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in modesList" :key="index" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="弹窗正文" prop="updateDesc" v-if="modes == 0">
            <el-input class="input_item" type="textarea" :rows="2" v-model="dialogUpdata.updateDesc"></el-input>
          </el-form-item>
        </el-form>
        <div v-if="modes == 1">
          <el-row>弹窗正文：</el-row>
          <div style="border: 1px solid #ccc">
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
              :mode="mode" />
            <Editor style="height: 300px; overflow-y: hidden" v-model="dialogUpdata.updateDesc"
              v-bind:value="dialogUpdata.updateDesc" :defaultConfig="editorConfig" :mode="mode"
              @onCreated="onCreated" />
          </div>
          <el-card class="box-card" v-if="boxShow">
            宽：<el-input type="number" placeholder="请输入宽" v-model="width" style="width: 200px" maxlength="10"
              show-word-limit>
            </el-input>
            <br />
            <div style="margin-top: 10px">
              高：<el-input type="number" placeholder="请输入高" v-model="height" style="width: 200px" maxlength="10"
                show-word-limit>
              </el-input>
            </div>
            <br />
            <div style="text-align: center; margin-top: 10px">
              <el-button size="mini" @click="sureChangeSize">确定</el-button>
            </div>
          </el-card>
        </div>
      </template>
      <template v-else>
        <el-row>
          <span>语言：</span>
          <el-select v-model="dialogUpdata.langCode" style="width: 150px" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in languageLists" :key="index" :label="item.language"
              :value="item.langCode">
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <span>悬浮按钮开关：</span>
          <el-switch v-model="dialogPromotUp.hoverButtonSwitch" active-text="打开" inactive-text="关闭"
            active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
        </el-row>
        <el-row>
          <span>悬浮图片：</span>
          <el-upload class="upload-demo" ref="upload6" action="" list-type="picture" :show-file-list="false" :limit="1"
            :on-change="(value) => changeFile2(5, value)" :auto-upload="false">
            <el-button slot="trigger" type="primary"> 选择图片 </el-button>
          </el-upload>
          <el-image style="width: 100px; height: 100px" :src="dialogPromotUp.hoverPicture"
            :preview-src-list="[dialogPromotUp.hoverPicture]" fit="contain">
          </el-image>
        </el-row>
        <el-row>
          <span>悬浮提示：</span>
          <el-input style="width: 200px; margin-left: 20px" class="input_item"
            v-model="dialogPromotUp.hoverPrompt"></el-input>
        </el-row>
      </template>

      <el-row>
        <el-button style="margin-left: 200px" type="primary" @click="cancles(2)">取消</el-button>
        <el-button type="primary" @click="dialogSubmit(2)">确认</el-button>
      </el-row>
    </el-dialog>
    <!-- 弹出文案列表 -->
    <el-dialog title="弹窗文案列表" :visible.sync="dialogTextListShow" width="60%">
      <el-row><el-button type="primary" @click="
        () => {
          dialogTextShow = true
          dialogTexgIn =
            dialogType == 0
              ? dialogTestList.length
              : dialogPromptList.length
        }
      ">添加</el-button></el-row>
      <el-table :data="dialogType == 0 ? dialogTestList : dialogPromptList" style="width: 100%">
        <el-table-column label="语言" align="center">
          <template slot-scope="scope">
            {{
              languageLists.find((item) => item.langCode == scope.row.langCode)
                .language
            }}
          </template>
        </el-table-column>
        <temlplate v-if="dialogType == 0">
          <el-table-column prop="windowsTitle" label="弹窗标题" align="center"></el-table-column>
          <el-table-column prop="buttonDesc" label="按钮文字" align="center"></el-table-column>
          <el-table-column prop="updateDesc" label="弹窗正文" align="center"></el-table-column>
        </temlplate>
        <template v-else>
          <el-table-column prop="hoverPicture" label="悬浮图" align="center">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: auto" :src="scope.row.hoverPicture"
                :preview-src-list="[scope.row.hoverPicture]"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="hoverPrompt" label="悬浮提示" align="center"></el-table-column>
          <el-table-column prop="hoverPicture" label="悬浮开关" align="center">
            <template slot-scope="scope">
              {{ scope.row.hoverButtonSwitch == 1 ? '开' : '关' }}
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" align="center" fixed="right" width="260">
          <template slot-scope="scope">
            <el-button type="primary" @click="dialogTextUp(scope.row, scope.$index)">修改</el-button>
            <el-button type="danger" @click="
              dialogType == 0
                ? dialogTestList.splice(scope.$index, 1)
                : dialogPromptList.splice(scope.$index, 1)
              ">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-button style="margin-left: 200px" type="primary" @click="cancles(1)">取消</el-button>
        <el-button type="primary" @click="dialogSubmit(1)">确认</el-button>
      </el-row>
    </el-dialog>
    <!-- 视频预览对话框 -->
    <el-dialog 
      title="视频预览" 
      :visible.sync="videoPreviewVisible" 
      width="80%"
      :before-close="closeVideoPreview">
      <div class="video-preview-container">
        <video 
          v-if="videoPreviewVisible && currentVideoUrl"
          :src="currentVideoUrl" 
          controls 
          style="width: 100%; max-height: 70vh;"
          @loadstart="videoLoading = true"
          @canplay="videoLoading = false"
          @error="handleVideoError">
        </video>
        <div v-if="videoLoading" class="video-loading">
          <i class="el-icon-loading"></i>
          <span>视频加载中...</span>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="closeVideoPreview">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { DomEditor } from '@wangeditor/core'
import { SlateTransforms, updateImageNode } from '@wangeditor/editor'
import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '@/store'

export default {
  name: 'AppUpdatePage',
  components: { Editor, Toolbar },
  data() {
    return {
      boxShow: false,
      width: '',
      height: '',
      dialogType: 0, //0弹窗 1//悬浮弹窗
      editor: null,
      html: '<p></p>',
      toolbarConfig: {},
      editorConfig: {
        hoverbarKeys: {
          image: {
            // 清空 image 元素的 hoverbar
            menuKeys: [
              'imageWidth30',
              'imageWidth50',
              'imageWidth100',
              'editImage',
              'viewImageLink',
              'deleteImage',
              'setSize',
            ],
          },
        },
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            server: '/api/upload',
            async customUpload(file, insertFn) {
              // JS 语法
              const formData = new FormData()
              formData.append('file', file)
              formData.append('cover', 0)
              formData.append('dir', 'app_icon/')
              console.log(this)
              const { data: res } = await service.post(
                store.getters.path.hostmgr_upload +
                '?username=' +
                store.getters.username +
                '&token=' +
                store.getters.token,
                formData
              )
              insertFn(res.data, '', res.data)
            },
          },
          uploadVideo: {
            server: '/api/upload',
            async customUpload(file, insertFn) {
              // JS 语法
              const formData = new FormData()
              formData.append('file', file)
              formData.append('cover', 0)
              formData.append('dir', 'app_icon/')
              const { data: res } = await service.post(
                store.getters.path.hostmgr_upload +
                '?username=' +
                store.getters.username +
                '&token=' +
                store.getters.token,
                formData
              )
              insertFn(res.data, '', res.data)
            },
          },
        },
      },
      mode: 'default', // or 'simple'
      dialogTextShow: false,
      dialogTextListShow: false,
      videoPreviewVisible: false,
      currentVideoUrl: '',
      videoLoading: false,
      curChannel: {
        selectValue: 'googleplay_lile',
        content: '',
      },
      modes: 0, // 0 普通文本 1 富文本
      modesList: [
        {
          name: '普通文本',
          value: 0,
        },
        {
          name: '富文本',
          value: 1,
        },
      ],
      // 国家列表
      dialogTexgIn: 0,
      dialogUpdata: {
        langCode: 'en',
        windowsTitle: '',
        buttonDesc: '',
        updateDesc: '',
      },
      dialogPromotUp: {
        langCode: 'en',
        hoverButtonSwitch: 0,
        hoverPicture: '',
        hoverPrompt: '',
      },
      imgStyle: {},
      languageLists: [],
      dialogPromptList: [],
      copyDialogRromptList: [],
      dialogTestList: [],
      copyDialogTestList: [],
      dialogText: [],
      channels: [],
      table: [],
      formData: {
        updateName: '',
        updateSwitch: 0,
        migrateCodeSwitch: 0,
        androidUpdateType: 0,
        payUserUpdateSwitch: 0,
        activeUserUpdateSwitch: 0,
        updateFrequency: 0,
        active: 0,
        displayPic1: '',
        displayPic2: '',
        newAppLogo: '',
        videoUrl: '',
        imgUrl: '',
        activeTotalDays: 0,
        payTotalAmount: 0,
        updatePromptInterval: 0,
        payUpdatePromptRange: '',
      },
      showDetail: false,
      loading: false,
      dateAry: '',
      type: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      rules: {
        channel: [
          {
            required: true,
            message: '请查询渠道后操作',
            trigger: 'blur',
          },
        ],
        updateName: [
          {
            required: true,
            message: '请填写版本更新名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    dialogTextShow(newVal) {
      if (newVal) {
        // 打开弹窗时，初始化 Editor
        this.$nextTick(() => {
          this.editor = null // 清空 editor 引用
        })
      } else {
        // 关闭弹窗时，销毁 Editor
        if (this.editor) {
          this.editor.destroy()
          this.editor = null
        }
      }
    },
    modes(newVal, oldVal) {
      if (oldVal === 1 && newVal === 0) {
        // 从富文本切换到普通文本时，销毁 Editor
        if (this.editor) {
          this.editor.destroy()
          this.editor = null
        }
      }
    },
  },
  mounted() {
    this.getChannel()
    this.getCountryCode()
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
    this.editor = null // 清空 editor 引用
  },
  methods: {
    cancles(types) {
      this.modes = 0
      if (types == 1) {
        this.dialogTestList = this.copyDialogTestList
        this.dialogPromptList = this.copyDialogRromptList
        this.dialogTextListShow = false
      } else {
        this.dialogTextShow = false
        if (this.dialogType == 0) {
          this.dialogUpdata = {
            langCode: 'en',
            windowsTitle: '',
            buttonDesc: '',
            updateDesc: '',
          }
          const editor = this.editor
          if (editor == null) return
          editor.destroy()
          this.imgStyle = {}
          this.height = ''
          this.width = ''
          this.boxShow = false
        } else {
          this.dialogPromotUp = {
            langCode: 'en',
            hoverButtonSwitch: 0,
            hoverPicture: '',
            hoverPrompt: '',
          }
        }
      }
    },
    dialogSubmit(types) {
      if (types == 1) {
        let info
        if (this.dialogType == 0) {
          info = this.transformArray(this.dialogTestList)
        } else {
          info = this.transformArray(this.dialogPromptList)
        }
        console.log(info)
        this.formData = { ...this.formData, ...info }
        console.log(this.formData)
        this.dialogTextListShow = false
      } else {
        this.dialogTextShow = false
        if (this.dialogType == 0) {
          this.$set(this.dialogTestList, this.dialogTexgIn, this.dialogUpdata)
          console.log(this.dialogTestList)
        } else {
          this.$set(
            this.dialogPromptList,
            this.dialogTexgIn,
            this.dialogPromotUp
          )
        }
        this.cancles(2)
      }
    },
    dialogTextUp(info, indexs) {
      console.log(indexs)
      this.dialogTexgIn = indexs
      if (this.dialogType == 0) {
        this.dialogUpdata = {
          ...info,
        }
      } else {
        this.dialogPromotUp = {
          ...info,
        }
      }
      this.dialogTextShow = true
    },
    sureChangeSize() {
      const props = {
        style: {
          ...this.imgStyle,
          width: this.width + 'px', // 修改 width
          height: this.height + 'px', // 清空 height
        },
      }

      this.editor.restoreSelection()
      SlateTransforms.setNodes(this.editor, props, {
        match(n) {
          return DomEditor.checkNodeType(n, 'image')
        },
      })
      this.boxShow = false
    },
    async execImgFn(imageNode) {
      if (imageNode == null) return

      const hoverbar = DomEditor.getHoverbar(this.editor)
      if (hoverbar) hoverbar.hideAndClean()
      const { style = {} } = imageNode
      this.imgStyle = style
      setTimeout(() => {
        this.boxShow = true
      }, 10)
    },
    onCreated(editor) {
      if (this.editor) return // 如果 editor 已经存在，直接返回
      this.editor = Object.seal(editor) // 初始化 editor
      editor.on('execImgFn', (val) => {
        this.execImgFn(val)
      })
    },
    //获取语言选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.langList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.languageLists = res.data
      }
    },
    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channels = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    // 删除
    async delete(info) {
      const res = await this.$axios.post(
        this.$store.getters.path.operations_delete_config,
        info
      )
      if (res.data.code !== 0) {
        return this.$message({
          showClose: true,
          message: res.data.msg,
          type: 'error',
        })
      }
      this.$message({
        showClose: true,
        message: 'update config success',
        type: 'success',
      })
      this.getConfig()
    },
    // 复制配置
    async copyConfig(info) {
      const res = await this.$axios.post(
        this.$store.getters.path.operations_copy_config,
        {
          updateId: info.updateId,
          channel: this.curChannel.selectValue,
        },
        {
          params: {
            username: this.username,
            token: this.token,
            channel: this.curChannel.selectValue,
          },
        }
      )
      if (res.data.code !== 0) {
        return this.$message({
          showClose: true,
          message: res.data.msg,
          type: 'error',
        })
      }
      this.$message({
        showClose: true,
        message: '复制配置成功',
        type: 'success',
      })
      this.getConfig()
    },
    transformArray(input) {
      const result = {}

      // 遍历输入数组
      input.forEach((item) => {
        const { langCode, ...rest } = item // 解构出 langCode 和其他字段

        // 遍历动态字段
        Object.entries(rest).forEach(([field, value]) => {
          if (!result[field]) {
            result[field] = {} // 初始化字段对象
          }
          result[field][langCode] = value // 按 langCode 分组
        })
      })

      // 将对象转换为字符串
      return Object.fromEntries(
        Object.entries(result).map(([field, value]) => [
          field,
          JSON.stringify(value), // 转换为字符串并替换双引号为单引号
        ])
      )
    },
    mergeObjectsByLangCode(arrays) {
      const resultMap = new Map() // 用于按 langCode 合并数据

      // 遍历每个数组
      arrays.forEach((array) => {
        array.forEach((item) => {
          const { langCode, ...rest } = item

          // 如果 langCode 不存在，初始化一个对象
          if (!resultMap.has(langCode)) {
            resultMap.set(langCode, { langCode })
          }

          // 合并当前对象的属性
          Object.assign(resultMap.get(langCode), rest)
        })
      })

      // 将 Map 转换为数组
      return Array.from(resultMap.values())
    },
    // 格式话代码
    transformString(input, names) {
      if (!input) {
        input = ''
      }

      try {
        // 尝试将输入解析为 JSON 对象
        const parsedInput = JSON.parse(input)

        if (typeof parsedInput === 'object' && !Array.isArray(parsedInput)) {
          // 如果是对象，将其转换为目标格式
          return Object.entries(parsedInput).map(([langCode, value]) => ({
            langCode,
            [names]: value,
          }))
        } else if (typeof parsedInput === 'string') {
          // 如果是纯字符串，默认转换为英文
          return [{ langCode: 'en', [names]: parsedInput }]
        } else {
          // 其他情况返回空数组
          return []
        }
      } catch (error) {
        // 如果解析失败，尝试手动提取 langCode 和值
        const regex = /\{'(\w+)':'(.*?)'\}/
        const match = input.match(regex)

        if (match) {
          const langCode = match[1]
          const value = match[2]
          return [{ langCode, [names]: value }]
        } else {
          // 如果无法提取，将输入作为纯字符串处理
          return [{ langCode: 'en', [names]: input }]
        }
      }
    },
    //获取视频通话数据
    getConfig() {
      // console.log(this.transformString("{'en':'asdf','ar':'asdfa'}", 'up'))
      // console.log(this.mergeObjectsByLangCode( [[{ langCode: "en", description: "asdf" }],[{ langCode: "en", message: "asdfas" }],[{ langCode: "ar", message: "asdfas" }]]))
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.operations_update_get_config,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          channel: this.curChannel.selectValue,
        },
      })
        .then(
          (res) => {
            if (res.data.code === 0) {
              this.showDetail = false
              this.table = res.data.data
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              })
            }
          },
          (err) => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error',
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    add() {
      this.type = 0
      this.showDetail = true
      this.formData = {
        channel: this.curChannel.selectValue,
        updateName: '',
        updateSwitch: 0,
        migrateCodeSwitch: 0,
        androidUpdateType: 0,
        payUserUpdateSwitch: 0,
        activeUserUpdateSwitch: 0,
        updateFrequency: 0,
        active: 0,
        displayPic1: '',
        displayPic2: '',
        newAppLogo: '',
        videoUrl: '',
        imgUrl: '',
        activeTotalDays: 0,
        payTotalAmount: 0,
        updatePromptInterval: 0,
        payUpdatePromptRange: '',
      }
      this.dialogTestList = []
      this.dialogPromptList = []
      this.copyDialogTestList = []
      this.copyDialogRromptList = []
    },
    change(info, type) {
      const buttons = this.transformString(info.buttonDesc, 'buttonDesc')
      const titles = this.transformString(info.windowsTitle, 'windowsTitle')
      const desc = this.transformString(info.updateDesc, 'updateDesc')
      const prompt = this.transformString(info.hoverPrompt, 'hoverPrompt')
      const picture = this.transformString(info.hoverPicture, 'hoverPicture')
      const switchs = this.transformString(
        info.hoverButtonSwitch,
        'hoverButtonSwitch'
      )
      this.dialogTestList = this.mergeObjectsByLangCode([buttons, titles, desc])
      this.dialogPromptList = this.mergeObjectsByLangCode([
        prompt,
        picture,
        switchs,
      ])
      this.info = { ...info, ...this.transformArray(this.dialogTestList) }
      this.copyDialogTestList = JSON.parse(JSON.stringify(this.dialogTestList))
      this.copyDialogRromptList = JSON.parse(
        JSON.stringify(this.dialogPromptList)
      )
      if (type == 1) {
        this.showDetail = true
        this.formData = { ...info }
        // 确保 videoUrl 字段存在，如果后端没有返回则初始化为空字符串
        if (!('videoUrl' in this.formData) || this.formData.videoUrl === null || this.formData.videoUrl === undefined) {
          this.$set(this.formData, 'videoUrl', info.videoUrl || '')
        }
        this.type = 1
        if (info.updateStartDate && info.updateEndDate) {
          this.dateAry = [info.updateStartDate, info.updateEndDate]
        }
      } else if (type == 2) {
        this.delete(info)
      } else {
        this.formData = info
        this.formData.active = Math.abs(info.active - 1)
        this.updateConfig('form')
      }
    },
    changeFile1(file) {
      console.log(file)
      this.formData.defaultImgFile = file.raw
      this.formData.imgUrl = URL.createObjectURL(file.raw)
      this.$refs.upload.clearFiles()
    },
    async changeFile2(type, file) {
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'app_icon/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formdata
      )
      if (res.code !== 0) {
        if (type == 1) {
          this.$refs.upload2.clearFiles()
        } else if (type == 2) {
          this.$refs.upload3.clearFiles()
        } else if (type == 3) {
          this.$refs.upload4.clearFiles()
        } else if (type == 6) {
          this.$refs.uploadVideo.clearFiles()
        }
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      if (type == 1) {
        this.formData.displayPic1 = res.data
        this.$refs.upload2.clearFiles()
      } else if (type == 2) {
        this.formData.displayPic2 = res.data
        this.$refs.upload3.clearFiles()
      } else if (type == 3) {
        this.formData.newAppLogo = res.data
        this.$refs.upload4.clearFiles()
      } else if (type == 4) {
        this.formData.imgUrl = res.data
        this.$refs.upload1.clearFiles()
      } else if (type == 5) {
        this.dialogPromotUp.hoverPicture = res.data
        this.$refs.upload6.clearFiles()
      } else if (type == 6) {
        this.$set(this.formData, 'videoUrl', res.data)
        this.$refs.uploadVideo.clearFiles()
      }
    },
    //更新配置
    updateConfig(formName) {
      //   return;
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        // let param = new URLSearchParams();
        let param = new FormData()
        param.append('username', this.username)
        param.append('token', this.token)
        Object.getOwnPropertyNames(this.formData).forEach((key) => {
          if (
            key !== 'updateStartDate' &&
            key !== 'updateEndDate' &&
            key !== '__ob__'
          ) {
            param.append(key, this.formData[key])
          }
        })

        if (this.dateAry[0]) {
          this.formData.updateStartDate = this.dateAry[0]
          param.append('updateStartDate', this.dateAry[0])
        }
        if (this.dateAry[1]) {
          this.formData.updateEndDate = this.dateAry[1]
          param.append('updateEndDate', this.dateAry[1])
        }
        this.$axios
          .post(
            this.$store.getters.path.operations_update_config,
            this.formData,
            {
              params: {
                username: this.username,
                token: this.token,
                channel: this.curChannel.selectValue,
              },
            }
          )
          .then(
            (res) => {
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: 'update config success',
                  type: 'success',
                })
                this.getConfig()
                this.showDetail = false
              } else if (res.data.code === 1001) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                })
                this.$router.push(this.$route.query.redirect || '/login')
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                })
              }
            },
            (err) => {
              this.$message({
                showClose: true,
                message: '请求错误:' + err,
                type: 'error',
              })
            }
          )
          .then(() => {
            this.loading = false
          })
      })
    },
    // 预览视频
    previewVideo(videoUrl) {
      this.currentVideoUrl = videoUrl
      this.videoPreviewVisible = true
    },
    // 关闭视频预览
    closeVideoPreview() {
      this.videoPreviewVisible = false
      this.currentVideoUrl = ''
      this.videoLoading = false
    },
    // 处理视频加载错误
    handleVideoError() {
      this.videoLoading = false
      this.$message.error('视频加载失败')
    },
    // 删除视频
    removeVideo() {
      this.$confirm('确定要删除这个视频吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(this.formData, 'videoUrl', '')
        this.$message.success('已删除视频')
      }).catch(() => {})
      //
      // this.$axios({
      //     type: 'POST',
      //     url: this.$store.getters.path.operations_update_config,
      //     withCredentials: true,
      //     params:{
      //         username: this.username,
      //         token: this.token,
      //         channel: this.formData.channel,
      //         trans_to_channel: this.formData.trans_to_channel,
      //         update_url: this.formData.update_url,
      //         active: this.formData.active,
      //         recharge: this.formData.recharge,
      //         force_update: this.formData.force_update,
      //         recharge_switch: this.formData.recharge_switch,
      //         home_page_switch: this.formData.home_page_switch,
      //         official_switch: this.formData.official_switch,
      //         send_msg_switch: this.formData.send_msg_switch,
      //         home_page_recharge: this.formData.home_page_recharge,
      //         home_page_activity: this.formData.home_page_activity,
      //         home_page_recharge_force: this.formData.home_page_recharge_force,
      //         home_page_activity_force: this.formData.home_page_activity_force,
      //         download_message: this.formData.download_message,
      //         official_notification_recharge: this.formData.official_notification_recharge,
      //         official_notification_activity: this.formData.official_notification_activity,
      //     }
      // }).then(res => {
      //         if(res.data.code === 0){
      //             this.$message({
      //                 showClose: true,
      //                 message: "update config success",
      //                 type: 'success'
      //             })
      //         } else if (res.data.code === 1001) {
      //             this.$message({
      //                 showClose: true,
      //                 message: res.data.msg,
      //                 type: 'error'
      //             })
      //             this.$router.push(this.$route.query.redirect || '/login');
      //         } else{
      //             this.$message({
      //                 showClose: true,
      //                 message: res.data.msg,
      //                 type: 'error'
      //             });
      //         }
      //     }, err => {
      //         this.$message({
      //             showClose: true,
      //             message: '请求错误:' + err,
      //             type: 'error'
      //         });
      //     }
      // ).then(()=>{
      //         this.loading = false;
      //     }
      // )
    },
  },
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    },
  },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="styl" scoped>
@import '../../../assets/stylus/variable.styl';
</style>
<style lang="scss" scoped>
.user-options {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}

.app_update_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .content {
    margin-top: 40px;
  }

  .input_item {
    width: 400px;
  }
}

.box-card {
  // <!-- position: absolute; -->
  top: 200px;
  left: 200px;
}
</style>
